import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CombiningStyleFunctionsDemo from './CombiningStyleFunctionsDemo';
import ClientProvider from './client';
export default createDemo(import.meta.url, CombiningStyleFunctionsDemo, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/getting-started/custom-components/demos/combining-style-functions-demo/CombiningStyleFunctionsDemo.tsx",
    "fileName": "CombiningStyleFunctionsDemo.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import styled from 'styled-components';\nimport { palette, spacing } from '@mui/system';\nimport type { PaletteProps, SpacingProps } from '@mui/system';\n\nconst Div = styled.div<PaletteProps & SpacingProps>`\n  ${palette}\n  ${spacing}\n`;\n\nexport default function CombiningStyleFunctionsDemo() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Div color=\"white\" bgcolor=\"palevioletred\" p={1}>\n      Styled components\n    </Div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 16,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import styled from 'styled-components';\nimport { palette, spacing } from '@mui/system';\nimport type { PaletteProps, SpacingProps } from '@mui/system';\n\nconst Div = styled.div<PaletteProps & SpacingProps>`\n  ${palette}\n  ${spacing}\n`;\n\nexport default function CombiningStyleFunctionsDemo() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Div color=\"white\" bgcolor=\"palevioletred\" p={1}>\n      Styled components\n    </Div>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Div"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "white",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "bgcolor"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "palevioletred",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "p"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            "      Styled components"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "Div"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 16,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "styled-components",
      "@mui/system"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
